// RxJS
// NGRX
import { Store, select } from '@ngrx/store';
// CRUD
import { BaseDataSource } from '../../_base/crud';
// State
import { AppState } from '../../reducers';
import {
  selectContactsLoginHistoryInStore,
  selectContactsLoginHistoryPageLoading,
  selectContactsLoginHistoryShowInitWaitingMessage,
} from '../_selectors/contacts-login-history.selectors';

export class ContactsLoginHistoryDatasource extends BaseDataSource {
  constructor(private store: Store<AppState>) {
    super();

    this.loading$ = this.store.pipe(select(selectContactsLoginHistoryPageLoading));

    this.isPreloadTextViewed$ = this.store.pipe(
      select(selectContactsLoginHistoryShowInitWaitingMessage),
    );

    this.store.pipe(select(selectContactsLoginHistoryInStore)).subscribe((response: any) => {
      this.paginatorTotalSubject.next(response.totalCount);
      this.entitySubject.next(response.items);
    });
  }
}
